import React, { useState } from 'react';
import { toast } from 'react-hot-toast';

import { updateBotStatus } from '../../services/api'; // We will create this
import { DataState } from '../../context/DataProvider';

const BotToggleButton = ({ bot, onUpdate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { userGoogleId: accessToken } = DataState(); // Assumes accessToken is in your context

  // A bot is "On" if its 'disabled' field is not true.
  // We check for `!bot.disabled` to handle cases where the field might be missing.
  const isOn = !bot.disabled;

  const handleToggle = async () => {
    if (!accessToken) {
      toast.error('Authentication error. Please log in again.');
      return;
    }

    setIsLoading(true);
    const newDisabledState = !bot.disabled;

    try {
      const payload = {
        disabled: newDisabledState,
      };

      // Call the new API function for updating bot status
      await updateBotStatus(bot.id, payload, accessToken);

      // Update the parent component's state to reflect the change in the UI
      onUpdate(bot.id, newDisabledState);

      toast.success(`Bot turned ${newDisabledState ? 'Off' : 'On'}`);
    } catch (error) {
      toast.error(error.message || 'Failed to update bot status.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-shrink-0">
      <div className="relative inline-flex cursor-pointer items-center">
        <input
          type="checkbox"
          className="peer sr-only"
          checked={isOn}
          onChange={handleToggle}
          disabled={isLoading}
        />
        <div
          className={`peer relative h-7 w-14 rounded-full bg-zinc-700 transition
            duration-300 after:absolute after:left-0.5
            after:top-1 after:h-5
            after:w-5 after:rounded-full after:bg-white after:transition-all after:duration-300
            peer-checked:bg-[#5652CF] peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[#1f529e]
            ${isOn ? 'after:translate-x-7' : ''}
            ${isLoading ? 'cursor-not-allowed opacity-50' : ''}`}
        >
          <span
            className={`absolute top-1.5 text-xs font-bold ${
              isOn ? 'left-2 text-white' : 'right-2 text-gray-300'
            }`}
          >
            {isOn ? 'On' : 'Off'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BotToggleButton;
